import { formatWallet } from "./helpers";

export const DEFAULT_WALLET_MESSAGE = "Hola {{nombre}} 👋\n\n🏦 Tu saldo disponible en el monedero es *{{saldo}}*.\n\n{{detalle_canje}}\n\nConsúltalo cuando quieras escribiendo *SALDO*. ¡Gracias por tu preferencia!";
export const walletMessageFor = (template) => {
  const text = String(template || "").trim();
  return text && !/\bpuntos?\b|\{\{\s*puntos\s*\}\}/i.test(text) ? text : DEFAULT_WALLET_MESSAGE;
};

export const WALLET_MESSAGE_VARS = [
  { key: "nombre", label: "Nombre", sample: "Laura", color: "#00695c" },
  { key: "nombre_cliente", label: "Cliente", sample: "Laura", color: "#00695c" },
  { key: "saldo", label: "Saldo disponible", sample: "$8.610 COP", color: "#16a34a" },
  { key: "detalle_canje", label: "Qué puede renovar", sample: "✅ Te alcanza para renovar Spotify con la opción Pagar con saldo.", color: "#0284c7" },
  { key: "servicios_canjeables", label: "Servicios que alcanza a renovar", sample: "Spotify · Premium", color: "#4527a0" },
  { key: "total_renovar", label: "Total para renovar", sample: "$6.000 COP", color: "#546e7a" },
];

/** La API actual puede omitir la moneda histórica; no sustituirla por la moneda actual. */
export const formatWalletMovement = (value, currency) => currency
  ? formatWallet(value, currency)
  : Number(value || 0).toLocaleString("es-CO", { maximumFractionDigits: 2 });
